export const WORKFLOW_DATA_LOADED = 'workflow/DATA_LOADED';
